module.exports = __webpack_public_path__ + "static/media/r3.62b18f7a.png";